import { components } from "../../services/api/onboarding/types";

export type IAcknowledgements = components["schemas"]["AcknowledgementName"][];

export enum WalletCardType {
  Physical = "physical",
  Virtual = "virtual"
}
